import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import {
  Button,
  Message,
  Modal,
  Title,
  InfoBlockItems,
} from "shared/components";
import { Spacer } from "shared/layout";
import {
  ITheme,
  IAPIState,
  IStatus,
  IPaginationItem,
  IPlace,
  IContact,
  IFile,
  IImageItem,
} from "shared/types";
import {
  ChooseInfoBlockItemBaseProps,
  getInfoBlockItemIcon,
} from "shared/utils";

interface ChooseInfoBlockItemModalProps
  extends Omit<ChooseInfoBlockItemBaseProps, "handleAddNew"> {
  getItemsApiStatus?: IAPIState;
  pagination: IPaginationItem;
  items: (IPlace | IContact | IFile | IImageItem)[];
  fetchItems: (page?: number) => void;
  openCreateModal: () => void;
  itemReadbleName: string;
}

export const ChooseInfoBlockItemModal: React.FC<ChooseInfoBlockItemModalProps> =
  ({
    type,
    items,
    Component,
    getItemsApiStatus,
    pagination,
    fetchItems,
    openCreateModal,
    itemReadbleName,
    handleClose,
    patchInfoBlock,
    hasError,
    disabledItems,
    componentProps,
  }) => {
    return (
      <Modal
        handleClose={handleClose}
        title={copy.chooseInfoBlockItem.title.replace("%s", itemReadbleName)}
        data-testid={`choose_${type}_modal`}
        icon={getInfoBlockItemIcon(type)}
      >
        <Spacer size="l">
          <Spacer size="s">
            <Title
              asComponent="h3"
              title={copy.chooseInfoBlockItem.addNew}
              size="m"
            />
            <Button
              theme={ITheme.secondary}
              onClick={openCreateModal}
              data-testid={`add_new_${itemReadbleName}`}
            >
              <Plus />
              <span>
                {copy.chooseInfoBlockItem.cta.replace("%s", itemReadbleName)}
              </span>
            </Button>
          </Spacer>
          {items && (
            <InfoBlockItems
              items={items}
              Component={Component}
              componentProps={componentProps}
              type={type}
              title={copy.chooseInfoBlockItem.chooseExisting}
              loading={getItemsApiStatus === IAPIState.pending}
              pager={
                pagination && {
                  ...pagination,
                  onPageChange: fetchItems,
                }
              }
              chooseItem={(item) =>
                patchInfoBlock && patchInfoBlock(item, type)
              }
              disabledItems={disabledItems}
            />
          )}
          {hasError && (
            <Message
              status={IStatus.error}
              message={copy.errors.general}
              scrollOnMount
            />
          )}
          <Button theme={ITheme.secondary} onClick={handleClose}>
            {copy.form.cancel}
          </Button>
        </Spacer>
      </Modal>
    );
  };
